module.exports = __webpack_public_path__ + "assets/sendoso.3806fe70.png";